<template>
    <div class="container-fluid py-2">
        <b-card class="mb-4">
            <b-form @submit.prevent="search" class="mb-3">
                <b-form-group label="Search:">
                    <b-form-input
                        v-model="filter.search"
                        placeholder="Search awsAccountId, awsAccountName"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label="Created from date:">
                    <b-form-datepicker
                        v-model="filter.from"
                        today-button
                        reset-button
                        close-button
                        value-as-date
                    ></b-form-datepicker>
                </b-form-group>
                <b-form-group label="Created to date:">
                    <b-form-datepicker
                        v-model="filter.to"
                        today-button
                        reset-button
                        close-button
                        value-as-date
                    ></b-form-datepicker>
                </b-form-group>
                <div class="d-flex align-items-center">
                    <b-button type="submit" class="mr-3 w-25" variant="primary">
                        Search
                    </b-button>
                </div>
            </b-form>
        </b-card>

        <b-button @click="onClickAdd" class="px-5 mb-3" variant="primary"
            >Add</b-button
        >
        <b-table :fields="fields" :items="items">
            <template #cell(action)="data">
                <b-button
                    @click="onClickEdit(data)"
                    class="mr-1 mb-1"
                    variant="primary"
                    >Edit</b-button
                >
                <b-button
                    @click="onClickDetail(data)"
                    variant="primary"
                    class="mr-1 mb-1"
                    >Detail</b-button
                >
                <b-button
                    @click="onClickShared(data.item)"
                    variant="primary"
                    class="mr-1 mb-1"
                >
                    {{ data.item.isShared ? 'Cancel Share' : 'Share' }}
                </b-button>
            </template>
        </b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            @change="onChangePage"
        ></b-pagination>
        <AddOrEditPayerModal
            v-model="modalAddOrEdit"
            :current-data="currentData"
            @onDone="fetchData"
        ></AddOrEditPayerModal>
        <DetailPayerModal
            v-model="modalDetail"
            :aws-account-uuid="currentData?.id"
        ></DetailPayerModal>
    </div>
</template>

<script>
import {
    getPayerAwsAccounts,
    changePayerAccountStatus,
} from '@/services/aws.service';
import moment from 'moment';
import AddOrEditPayerModal from '@/views/Modals/AddOrEditPayerModal/AddOrEditPayerModal.vue';
import DetailPayerModal from '@/views/Modals/DetailPayerModal/DetailPayerModal.vue';

export default {
    name: 'HomeView',
    components: { DetailPayerModal, AddOrEditPayerModal },
    data() {
        return {
            modalDetail: false,
            modalAddOrEdit: false,
            currentData: null,
            filter: {
                search: '',
                from: '',
                to: '',
            },
            items: [],
            perPage: 10,
            currentPage: 1,
            total: 0,
            fields: [
                {
                    key: 'awsAccountId',
                    label: 'awsAccountId',
                },
                {
                    key: 'awsAccountName',
                    label: 'awsAccountName',
                },
                {
                    key: 'accessKeyId',
                    label: 'accessKeyId',
                },
                {
                    key: 'secretAccessKey',
                    label: 'secretAccessKey',
                },
                {
                    key: 'action',
                    label: 'action',
                },
            ],
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            const query = {
                search: this.filter.search || undefined,
                from: this.filter.from
                    ? moment(this.filter.from).startOf('day').toISOString()
                    : undefined,
                to: this.filter.to
                    ? moment(this.filter.to).endOf('day').toISOString()
                    : undefined,
                page: this.currentPage,
                limit: this.perPage,
            };
            getPayerAwsAccounts(query).then(({ data }) => {
                const { accounts, paginate } = data;
                this.items = accounts;
                this.perPage = paginate.perPage;
                this.currentPage = paginate.currentPage;
                this.total = paginate.total;
            });
        },
        search() {
            this.fetchData();
        },
        onChangePage(val) {
            this.currentPage = val;
            this.fetchData();
        },
        onClickEdit(data) {
            this.currentData = data.item;
            this.modalAddOrEdit = true;
        },
        onClickAdd() {
            this.currentData = null;
            this.modalAddOrEdit = true;
        },
        onClickDetail(data) {
            this.currentData = data.item;
            this.modalDetail = true;
        },
        onClickShared(item) {
            this.$bvModal
                .msgBoxConfirm('Are you sure?', {
                    title: 'Please Confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'YES',
                    cancelTitle: 'NO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((isYes) => {
                    if (isYes) {
                        changePayerAccountStatus(item.id, !item.isShared).then(
                            () => {
                                this.$bvToast.toast(`Update success!`, {
                                    title: 'Success',
                                    autoHideDelay: 5000,
                                    appendToast: true,
                                    variant: 'success',
                                    solid: false,
                                    toaster: 'b-toaster-top-center',
                                });
                                this.fetchData();
                            }
                        );
                    }
                });
        },
    },
};
</script>
